// components/tables/ShowTables/TableHeader.jsx
import React from "react";
import { Button } from "@/components/ui/Button";
import { CardHeader, CardTitle } from "@/components/ui/Card";

const TableHeader = ({ onJoinTables }) => {
  return (
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle className="text-xl font-semibold">
        Administración de Mesas
      </CardTitle>
      <Button
        onClick={onJoinTables}
        className="bg-orange-500 hover:bg-orange-600 text-white"
      >
        Unir Mesas
      </Button>
    </CardHeader>
  );
};

export default TableHeader;
